// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/seeds/dashboard-v2/auth-flows/verify-email.yaml
// Generator: tools/v2-gen/v2genauth.py
// Regenerate via: make v2-generate-auth-pages
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-auth-flow-spec.md §5
// for override blocks (imports / helpers / validation / success-action /
// state-render).

import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { apiClient } from "../../api/client";
import { AuthLayout } from "./AuthLayout";
import { errorStyle, ctaLinkStyle } from "./styles";
// override-block:imports BEGIN
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

type State = "verifying" | "success" | "error";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [state, setState] = useState<State>("verifying");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!token) {
        if (!cancelled) {
          setError("Missing verification token. Use the link from your verification email.");
          setState("error");
        }
        return;
      }
      try {
        await apiClient().post("/auth/verify-email", { token: token });
        if (!cancelled) {
          // override-block:success-action BEGIN
          // override-block:success-action END
          setState("success");
        }
      } catch (e: any) {
        if (!cancelled) {
          setError(e?.response?.data?.detail ?? "Verification failed. The link may have expired or already been used.");
          setState("error");
        }
      }
    }
    void run();
    return () => {
      cancelled = true;
    };
  }, [token]);

  // override-block:state-render BEGIN
  // override-block:state-render END

  if (state === "verifying") {
    return (
      <AuthLayout pageId="verify-email" title={"Verifying your email…"}>
        <div data-role="spinner" style={{ textAlign: "center", padding: 16 }}>
          <div
            style={{
              display: "inline-block",
              width: 24,
              height: 24,
              border: "3px solid var(--color-border)",
              borderTopColor: "var(--color-primary)",
              borderRadius: "50%",
              animation: "auth-spin 0.8s linear infinite",
            }}
          />
          <style>{`@keyframes auth-spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </AuthLayout>
    );
  }

  if (state === "success") {
    return (
      <AuthLayout pageId="verify-email" title={"Email verified"}>
        <p data-role="body" style={{ fontSize: 14, color: "var(--color-text)", textAlign: "center" }}>
          Your email address has been verified. You can now sign in.
        </p>
        <Link to="/login" data-action="goto-login" style={ctaLinkStyle()}>
          Continue to sign-in
        </Link>
      </AuthLayout>
    );
  }

  if (state === "error") {
    return (
      <AuthLayout pageId="verify-email" title={"Verification failed"}>
        <div data-role="error" style={errorStyle}>{error}</div>
        <Link to="/login" data-action="goto-login" style={ctaLinkStyle()}>
          Go to sign-in
        </Link>
      </AuthLayout>
    );
  }

  return null;
}
